/* eslint-disable arrow-body-style */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import AuthorizeModal from '../../components/Microsoft/AuthorizeModal';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import * as url from '../../helpers/url_helper';
import { post } from '../../helpers/api_helper';
import SmtpTestForm from '../../components/Settings/Smtp/SmtpTestForm';

function Microsoft(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authModalEntity, setAuthModalEntity] = useState(false);
  const [refresh, setRefresh] = useState(0);

  const newAuth = (app) => {
    setShowAuthModal(true);
    setAuthModalEntity(app);
  };

  const deleteAuth = (auth) => {
    try {
      post(url.DELETE_MICROSOFT_AUTHORIZATION, { id: auth.id });
      setRefresh(refresh + 1);
    } catch (err) {
      toastr.error(props.t('Could not delete authorization'));
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="10">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Microsoft App Registrations')}</CardTitle>

                <Can i="see" this="microsoft">
                  <BaseGrid
                    url={url.GET_MICROSOFT_APPS}
                    keyProp="microsoft_app_id"
                    shouldUpdate={refresh}
                    config={
                    {
                      columns: {
                        name: {
                          label: 'Name',
                          sort: true,
                        },
                        client_id: { label: 'Client ID', sort: true },
                        tenant_id: { label: 'Tenant ID' },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'auth',
                              icon: 'mdi mdi-lock-open-plus',
                              class: 'btn btn-sm btn-soft-success',
                              alt: props.t('New Authorization'),
                              click: newAuth,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'name',
                        direction: 'asc',
                        perPage: 10,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="microsoft"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xxl="10">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Microsoft App Authorizations')}</CardTitle>

                <Can i="see" this="microsoft">
                  <BaseGrid
                    url={url.GET_MICROSOFT_AUTHORIZATIONS}
                    keyProp="microsoft_id"
                    shouldUpdate={refresh}
                    config={
                    {
                      columns: {
                        email: {
                          label: 'Email',
                          sort: true,
                        },
                        app: {
                          label: 'App',
                          format: (x) => (
                            x.name
                          ),
                        },
                        scope: {
                          label: 'Scope',
                          badges: {
                            split: ',',
                            class: 'bg-primary',
                          },
                        },
                        created_at: {
                          label: 'Created At',
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: process.env.REACT_APP_LOCAL_TZ,
                          },
                        },
                        expires_at: {
                          label: 'Expires At',
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: process.env.REACT_APP_LOCAL_TZ,
                          },
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'delete',
                              icon: 'mdi mdi-close-thick',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteAuth,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'uid',
                        direction: 'asc',
                        perPage: 10,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="microsoft"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Card>
              <CardBody>
                <CardTitle className="h4">Test Fire</CardTitle>
                <p className="card-title-desc">
                  Send test emails
                </p>

                <SmtpTestForm actionUrl="/api/microsoft/smtp/test" />
              </CardBody>
            </Card>
          </Col>
        </Row>

        {authModalEntity !== false && (
          <AuthorizeModal
            entity={authModalEntity}
            shown={showAuthModal}
            onClose={() => setShowAuthModal(false)}
          />
        )}
      </div>
    </div>
  );
}

Microsoft.defaultProps = {
  t: (x) => (x),
};

Microsoft.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Microsoft));
